export const duoRibbonWidth = ({ isMinMd, duoLayout }: { isMinMd: boolean; duoLayout?: boolean }) => {
  if (!isMinMd || duoLayout == null) {
    return {};
  }

  const flexSize = isMinMd && duoLayout ? 50 : 100;
  return {
    flex: `${flexSize}%`,
  };
};

export default null;
